import { Component, ViewChild, ElementRef } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SeasonService } from './services/season.service';
import { TeamSeason } from './model/team-season';
import { TeamSeasonService } from './services/team-season.service';
import { TeamService } from './services/team.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html'
})

export class AppComponent {
  imageUrls: string[] = [
    "/assets/img/slideshow/header01.jpg",
    "/assets/img/slideshow/header02.jpg"
  ];

  teamSeasons: Map<String, TeamSeason> = new Map<String, TeamSeason>();
  @ViewChild("headerRight") headerRight: ElementRef;

  constructor(private readonly deviceService: DeviceDetectorService, private readonly seasonService: SeasonService,
    private teamSeasonService: TeamSeasonService, private readonly teamService: TeamService) { }

  private getSlideshowHeight(): number {
    return this.headerRight.nativeElement.offsetHeight;
  }

  ngOnInit(): void {
    this.seasonService.getSeasons().subscribe(seasons => {
      let mostRecentSeason = seasons.reduce((s1, s2) => new Date(s1.endDate).getTime() > new Date(s2.endDate).getTime() ? s1 : s2);
      this.teamSeasonService.getTeamSeasons().subscribe(teamSeasons => {
        teamSeasons.filter(ts => ts.seasonId === mostRecentSeason.seasonId).forEach(ts => {
          this.teamService.getTeams().subscribe(teams => {
            this.teamSeasons.set(teams.find(t => t.teamId === ts.teamId).name, ts);
          });
        });
      });
    });
  }
}
